import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { UserLoginServerFinalSchema } from './user-login-response.dto';
export const SsoUserLoginResponseSchema = z
    .object({
    email: z.string(),
})
    .extend(UserLoginServerFinalSchema.omit({
    userEncryptedKeyGen: true,
    userEncryptedKeyIterations: true,
}).shape);
export class SsoUserLoginResponseDto extends createZodDto(SsoUserLoginResponseSchema) {
}
